const settingsPathname = {
  SETTINGS: '/app/settings',
}

const usersPathname = {
  USERS: settingsPathname.SETTINGS + '/users',
}

const userPathname = {
  USER: (id) => usersPathname.USERS + `/${id}/profile`,
  USER_JOB_INFO: (id) => usersPathname.USERS + `/${id}/job-information`,
  USER_PRIVATE_INFO: (id) => usersPathname.USERS + `/${id}/private-information`,
  USER_SETTINGS_RRHH: (id) => usersPathname.USERS + `/${id}/settings-rrhh`,
}

const rolesPathname = {
  ROLES: settingsPathname.SETTINGS + '/roles',
  ROLE: (id) => settingsPathname.SETTINGS + `/roles/${id}`,
}

const companiesPathname = {
  COMPANIES: settingsPathname.SETTINGS + '/companies',
}

const mutualsPathname = {
  MUTUALS: settingsPathname.SETTINGS + '/mutuals',
}

const generalPathname = {
  BILLABLES: settingsPathname.SETTINGS + '/general/billables',
  CONVENTIONS: settingsPathname.SETTINGS + '/general/conventions',
  INPUTS: settingsPathname.SETTINGS + '/general/inputs',
  POPULATIONS: settingsPathname.SETTINGS + '/general/populations',
  STATES: settingsPathname.SETTINGS + '/general/states',
}

const centerPathname = {
  ASPIRATOR: settingsPathname.SETTINGS + '/centers/aspirator-types',
  COMERCIAL_DATA: settingsPathname.SETTINGS + '/centers/comercial-data',
  GAS_TYPES: settingsPathname.SETTINGS + '/centers/gas-types',
  HEATER_TYPES: settingsPathname.SETTINGS + '/centers/heater-types',
  OTHER_TECNICS_TYPES:
    settingsPathname.SETTINGS + '/centers/other-tecnics-types',
  PLATTEN_TYPES: settingsPathname.SETTINGS + '/centers/platten-types',
  SERVICES_TYPES: settingsPathname.SETTINGS + '/centers/services-types',
  SOAP_TYPES: settingsPathname.SETTINGS + '/centers/soap-types',
  TRACK_TYPES: settingsPathname.SETTINGS + '/centers/track-types',
  WASHING_TYPES: settingsPathname.SETTINGS + '/centers/washing-types',
  MAINTENANCE_TYPES: settingsPathname.SETTINGS + '/centers/maintenance-types',
}

export {
  settingsPathname,
  usersPathname,
  userPathname,
  rolesPathname,
  companiesPathname,
  mutualsPathname,
  generalPathname,
  centerPathname,
}
